//para habilitar https: set HTTPS=true&&set HOST=0.0.0.0&&
//HTTPS=true DANGEROUSLY_DISABLE_HOST_CHECK=true
//let url = 'https://p-lao.com:3000/graphql'; 
//let url = 'https://dev-back-end.p-lao.com/graphql'; 
let url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'https://app.pm502.com/graphql';
export default url
